/* eslint-disable no-unused-vars */
import firebase from 'firebase/app'
import { format, getQuarter } from 'date-fns'

import { db } from './firebase.service'

import { getWeekDates } from '@/helpers'

import { SurveyModel } from '@/models'

const getSurvey = (id) => {
  return new Promise((resolve, reject) => {
    db.collection('surveys')
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          resolve({ id: doc.id, ...doc.data() })
        } else {
          reject(new Error('Survey not found'))
        }
      })
      .catch((error) => {
        console.error(error)
        reject(error)
      })
  })
}

const updateSurvey = (id, data) => {
  return new Promise((resolve, reject) => {
    if (data?.year && data?.week) {
      const [start, end] = getWeekDates(data.year, data.week)
      const quarter = getQuarter(start)

      data.quarter = quarter
      data.start_date = format(start, 'yyyy-MM-dd')
      data.end_date = format(end, 'yyyy-MM-dd')
    }

    db.collection('surveys')
      .doc(id)
      .update({
        ...data,
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(resolve)
      .catch((error) => {
        console.error(error)
        reject(error)
      })
  })
}

const deleteSurvey = (id) => {
  return new Promise((resolve, reject) => {
    db.collection('surveys')
      .doc(id)
      .delete()
      .then(resolve)
      .catch((error) => {
        console.error(error)
        reject(error)
      })
  })
}

const bulkCreate = (data) => {
  return new Promise((resolve, reject) => {
    let batch = db.batch()

    data.forEach((doc) => {
      var docRef = db.collection('surveys').doc()

      const [start, end] = getWeekDates(doc.year, doc.week)
      const quarter = getQuarter(start)

      const survey = Object.assign({ ...SurveyModel }, doc, {
        quarter,
        start_date: format(start, 'yyyy-MM-dd'),
        end_date: format(end, 'yyyy-MM-dd'),
      })

      batch.set(docRef, {
        ...survey,
        token: crypto.randomUUID(),
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
      })
    })

    batch
      .commit()
      .then((data) => {
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const bulkDelete = (data) => {
  return new Promise((resolve, reject) => {
    let batch = db.batch()

    data.forEach((doc) => {
      var docRef = db.collection('surveys').doc(doc.id)
      batch.delete(docRef)
    })

    batch
      .commit()
      .then((data) => {
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  getSurvey,
  updateSurvey,
  deleteSurvey,
  bulkCreate,
  bulkDelete,
}
